import { messagingRequestsTyped } from "@/api/(requests)/messagingTyped";

export async function getUnreadMessageCount(): Promise<number> {
  const response = await messagingRequestsTyped.fetch_unread_message_count({
    context: {
      exceptionConfig: { ForbiddenException: { allowRetry: false } },
      preventAllErrorToast: true,
      showLoader: false,
    },
  });

  return response.unread_count;
}
